// extracted by css-extract-rspack-plugin
export default {"cls1":"Comments-cls1_wrM","cls2":"Comments-cls2_iNt Comments-cls1_wrM"};